import React, { useState } from 'react';
import styles from './FormRegisterTwo.module.scss';
import AddressesRegistrationForm from '../AddressesRegistrationForm/AddressesRegistrationForm';
import { templatesMode } from '../../../constants/templatesMode';
import TemplatesRegistrationForm from '../TemplatesRegistrationForm/TemplatesRegistrationForm';
import { modeList } from '../../../constants/modeList';

const FormRegisterTwo = ({
  activeLsTypes,
  // arrearProviders,
  houseTemplates,
  housesData,
  chengeHistory,
  choice,
  registrationTypeHouse,
}) => {
  const [templateModem, setTemplateModem] = useState(modeList.NOTHING_MODE);
  const TemplateComponent = templatesMode[templateModem];
  const [selectedTemlates, setSelectedTemlates] = useState(null);

  const changeTemlate = (tempalate) => {
    setSelectedTemlates(tempalate);
  };

  const changeTemlateModem = (str) => {
    setTemplateModem(str);
  };

  return (
    <div
      className={styles.conteiner}
      style={{
        gridTemplateColumns: `1.2fr 1.3fr 2fr`,
      }}
    >
      {templateModem === modeList.NOTHING_MODE ||
      templateModem === modeList.SELECTED_MODE ? (
        <AddressesRegistrationForm
          housesData={housesData}
          chengeHistory={chengeHistory}
        />
      ) : (
        ''
      )}
      <TemplatesRegistrationForm
        choice={choice}
        templateModem={templateModem}
        changeTemlateModem={changeTemlateModem}
        houseTemplates={houseTemplates}
        selectedTemlates={selectedTemlates}
        changeTemlate={changeTemlate}
      />

      <TemplateComponent
        activeLsTypes={activeLsTypes}
        // arrearProviders={arrearProviders}
        registrationTypeHouse={registrationTypeHouse}
        setSelectedTemlates={setSelectedTemlates}
        housesData={housesData}
        selectedTemlates={selectedTemlates}
        changeTemlateModem={changeTemlateModem}
        templateModem={templateModem}
      />
    </div>
  );
};

export default FormRegisterTwo;
